import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formatPageTitle, getPageTitleFromPath } from '../utils/pageTitle';

export const usePageTitle = (titleOverride?: string): void => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = titleOverride ? formatPageTitle(titleOverride) : getPageTitleFromPath(pathname);
  }, [pathname, titleOverride]);
};
